'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransmuteCollection = require('./TransmuteCollection');

var _immutable = require('immutable');

_TransmuteCollection.count.implement(Array, function (arr) {
  return arr.length;
});

_TransmuteCollection.count.implementInherited(_immutable.Iterable, function (subject) {
  return subject.count();
});

_TransmuteCollection.count.implement(Object, function (obj) {
  return Object.keys(obj).length;
});

_TransmuteCollection.count.implement(String, function (str) {
  return str.length;
});

exports.default = _TransmuteCollection.count;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_count.js
// module id = 75
// module chunks = 0 1